module.exports = __webpack_public_path__ + "content/abe34417b3b1e049d7f37074731189d5.svg";